"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBox = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useOrgUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/organisation/useOrgUpdate"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const consts_1 = require("@opsbase/web-app/consts");
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const ConfirmDialog_1 = __importDefault(require("@opsbase/web-dialogs/ConfirmDialog"));
const ChevronDownIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronDownIcon"));
const ChevronUpIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronUpIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNotificationActions_1 = __importDefault(require("@opsbase/web-notification/useNotificationActions"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const addChartToDashboard_1 = __importDefault(require("../helpers/addChartToDashboard"));
const ChartBoxCard_1 = __importDefault(require("./ChartBoxCard"));
const makeMyClasses = () => ({
    collapser: {
        position: 'absolute',
        left: '50%',
        bottom: -12,
        cursor: 'pointer',
    },
});
function ChartBox(props) {
    const { vertical = false } = props;
    const dt = (0, useDataTree_1.default)();
    const { chartBox, query } = (0, useView_1.default)(dt.viewId);
    const self = (0, useSelf_1.default)();
    const { raise, raiseError } = (0, useNotificationActions_1.default)();
    const { updateSettings } = (0, useSelfActions_1.default)();
    const [collapsed, setCollapsed] = (0, react_1.useState)(true);
    const updateOrg = (0, useOrgUpdate_1.default)();
    const isHidden = !chartBox.visible;
    const canAddToDashboard = self.isPrimary || self.isSuperUser;
    const [addingToDashboard, setAddingToDashboard] = (0, react_1.useState)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleConfirmAddToDashboard = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const existingWidgets = (_a = self === null || self === void 0 ? void 0 : self.settings) === null || _a === void 0 ? void 0 : _a.dashboardWidgets;
        if (existingWidgets.length >= consts_1.maxWidgetsPerDashboard)
            return raiseError(lib_i18n_1.default.t('dashboard-full'));
        const dashboardWidgets = (0, addChartToDashboard_1.default)(existingWidgets, query, addingToDashboard);
        return raise(updateOrg({
            id: self.organisationId,
            patch: { settings: { dashboardWidgets } },
        }).then(updatedOrg => {
            updateSettings(updatedOrg === null || updatedOrg === void 0 ? void 0 : updatedOrg.settings);
            return true;
        }), lib_i18n_1.default.t('successfully-added-to-dashboard'));
    }), [addingToDashboard, query, raise, raiseError, self, updateSettings, updateOrg]);
    const handleCancelAddToDashboard = (0, react_1.useCallback)(() => {
        setAddingToDashboard(undefined);
    }, []);
    const handleCollapse = (0, react_1.useCallback)(() => setCollapsed(!collapsed), [collapsed]);
    const charts = (0, react_1.useMemo)(() => chartBox.charts
        .filter(chart => !chart.hidden)
        .map((chart, idx) => (react_1.default.createElement(ChartBoxCard_1.default, { key: chart.chartType + idx, chart: chart, onAddToDashboard: canAddToDashboard ? setAddingToDashboard : undefined }))), [chartBox.charts, canAddToDashboard]);
    return (0, react_1.useMemo)(() => {
        if (!charts.length || !chartBox.visible)
            return null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            !vertical && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: myCss.collapser, onClick: handleCollapse }, collapsed ? (react_1.default.createElement(ChevronUpIcon_1.default, { size: 16 })) : (react_1.default.createElement(ChevronDownIcon_1.default, { size: 16 }))),
                react_1.default.createElement(core_1.Collapse, { in: collapsed },
                    react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true }, charts)))),
            vertical && (react_1.default.createElement(Vertical_1.default, { style: { marginLeft: isHidden ? 0 : 8 }, shrink: true, gutter: true }, charts)),
            !!canAddToDashboard && (react_1.default.createElement(ConfirmDialog_1.default, { open: !!addingToDashboard, color: lib_palette_1.default.positive, onConfirm: handleConfirmAddToDashboard, onClose: handleCancelAddToDashboard },
                react_1.default.createElement(Text_1.default, null, lib_i18n_1.default.t('confirm-add-to-dashboard'))))));
    }, [
        charts,
        chartBox.visible,
        vertical,
        myCss.collapser,
        handleCollapse,
        collapsed,
        isHidden,
        canAddToDashboard,
        addingToDashboard,
        handleConfirmAddToDashboard,
        handleCancelAddToDashboard,
    ]);
}
exports.ChartBox = ChartBox;
exports.default = ChartBox;
